module.exports = __webpack_public_path__ + "img/1.92c95113.jpg";